<!--
 * @Author: 刘小博
 * @Date: 2023-08-16 17:25:24
 * @LastEditTime: 2023-10-26 17:58:32
 * @LastEditors: Cclay
 * @Description: 
 * @FilePath: \zl_api_private_web\src\views\Scan.vue
 * 文件备注
-->
<template>
  <div class="scan">
    <div class="sacn_bg"></div>

    <div class="top_logo">
      <img src="./../assets/img/top_logo.png" alt="" />
      <div class="logo_title">为商业流向直连设计</div>
    </div>
    <div class="p2p_logo">
      <img src="./../assets/img/p2p_logo.png" alt="" />
    </div>
    <div class="right">
      <div class="code_box">
        <div class="title">流连宝账户登录</div>

        <div class="code">
          <div class="code-content" v-if="qrStatus === 1">
            <img class="qrcode" :src="qrImgSrc" alt="" />
          </div>
          <div v-if="qrStatus === 2" class="qrcode-success">
            <img
              class="qrcode"
              src="./../assets/img/img_success_login.png"
              alt=""
            />
            <h4 class="login-box_titles">扫描成功!</h4>
            <div>请在APP端确认登录</div>
          </div>
          <div v-if="qrStatus === 3" class="qrcode-error" @click="qrCodeLogin">
            <div class="login-boxes">
              <img
                class="qrcode"
                src="./../assets/img/img_QRcode_error.png"
                alt=""
              />
              <div class="qrcode-center">点击刷新二维码</div>
            </div>
            <div class="qrcode-error-footer">二维码已失效，请刷新！</div>
          </div>
          <div v-if="qrStatus === 4" class="qrcode-success qrcode-cancel">
            <img
              class="qrcode"
              src="./../assets/img/img_QRcode_cancel.jpg"
              alt=""
            />
            <h4 class="login-box_titles">APP取消授权!</h4>
            <div @click="qrCodeLogin" style="cursor: pointer">
              点击重新获取二维码
            </div>
          </div>

          <div v-if="qrStatus === 6" class="qrcode-success qrcode-cancel">
            <img
              class="qrcode"
              src="./../assets/img/img_QRcode_cancel.jpg"
              alt=""
            />
            <h4 class="login-box_titles">您的登录申请已拒绝!</h4>
            <div @click="qrCodeLogin" style="cursor: pointer">
              点击重新获取二维码
            </div>
          </div>
        </div>

        <div class="desc">
          支持正也扫码登录
          <!-- 销讯通扫码登录 -->
        </div>
      </div>
    </div>

    <div
      class="page-footer"
      v-bind:class="{ collapsed: $store.state.collapsed }"
    >
      Copyright &copy;{{ currentYear }} by 上海正也信息科技有限公司
      <a href="https://beian.miit.gov.cn/" class="beian" target="_blank"
        >沪ICP备14016032号-7</a
      >
    </div>
  </div>
</template>

<script>
import { qrCodeLogin } from "@/api";
export default {
  beforeCreate() {
    this.currentYear = new Date().getFullYear();
  },
  data() {
    return {
      qrImgSrc: "",
      qr_data: "",
      timeunixStart: 0,
      notConfirmTime: 0,
      qrTimer: null,
      qrStatus: 1,
    };
  },
  created() {
    console.log(this.$axios.defaults.baseURL, "this.$axios.defaults.baseURL");

    this.qrCodeLogin();
  },
  methods: {
    qrCodeLogin() {
      let that = this;
      this.qrImgSrc = "";
      this.clearQRtimer();
      this.qrStatus = 1;

      qrCodeLogin().then((res) => {
        console.log(res, "res");

        if (2 == res.status) {
          this.qr_data = res.data.qr_data;
          // if (this.$axios.defaults.baseURL)
          this.qrImgSrc =
            // https://admin.p2ps.vip/api/
            "http://admin.p2ps.vip/api/api/website/scan_code/qrCodeUrl?qr_data=" +
            this.qr_data;
          this.timeunixStart = new Date().valueOf();

          // 启动计时器，轮询移动端处理状态
          this.qrTimer = setInterval(() => {
            qrCodeLogin({
              qr_data: that.qr_data,
            }).then((res) => {
              // res.status = 12;
              // 状态4，移动端未操作
              if (4 == res.status) {
                // 5分钟没有扫码，二维码过期
                if (new Date().valueOf() - that.timeunixStart > 1000 * 60 * 2) {
                  that.clearQRtimer();
                  that.qrImgSrc = "";
                  that.qrStatus = 3;
                }
                return;
              }

              // 状态1，移动端二维码错误，显示刷新页面
              if (1 == res.status) {
                that.clearQRtimer();
                that.qrImgSrc = "";
                that.qrStatus = 3;
                return;
              }
              // 扫码成功，未确认
              if (5 == res.status) {
                if (that.notConfirmTime === 0) {
                  that.notConfirmTime = new Date().valueOf();
                }

                // 5分钟没有扫码，二维码过期
                if (
                  new Date().valueOf() - that.notConfirmTime >
                  1000 * 60 * 2
                ) {
                  that.clearQRtimer();
                  that.notConfirmTime = 0;
                  that.qrImgSrc = "";
                  that.qrStatus = 3;
                  return;
                }
                that.qrImgSrc = "";
                that.qrStatus = 2;
              }
              // 扫码成功，app取消登录
              if (6 == res.status) {
                that.clearQRtimer();
                that.qrImgSrc = "";
                that.qrStatus = 4;
                return;
              }
              // 扫码成功，协助人员拒绝
              if (13 == res.status) {
                that.clearQRtimer();
                that.qrImgSrc = "";
                that.qrStatus = 6;
                return;
              }

              // 状态0，移动端二维码确认登录成功，首页跳转
              if (0 == res.status) {
                that.clearQRtimer();
                // 扫码成功跳转到首页

                that.$store.state.funcModuleArray =
                  res.data.company_row.navigation.funcModuleArray || [];
                that.$store.state.isQiyeLogin = 1;

                that.$router.push({ name: "home" });
                return;
              }
            });
          }, 5000);
        }
      });
    },
    clearQRtimer() {
      clearInterval(this.qrTimer);
      this.qrTimer = null;
    },
  },
};
</script>

<style scoped lang="scss">
.scan {
  width: 100%;
  height: 100vh;
  background-image: url("~@/assets/img/bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .sacn_bg {
    width: 22.7%;
    height: 21.53%;
    position: absolute;
    left: 22.66%;
    top: 23.15%;
    background-image: url("~@/assets/img/sacn_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .top_logo {
    display: flex;
    padding-top: 20px;
    padding-left: 30px;
    align-items: center;
    .logo_title {
      margin-left: 30px;
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .p2p_logo {
    position: absolute;
    right: 20px;
    top: 20px;
  }

  .right {
    position: absolute;
    left: 58%;
    top: 17%;

    .logo_bg {
      width: 380px;
      height: 120px;
      background-image: url("~@/assets/img/logo_bg.png");
    }

    .code_box {
      margin-top: 50px;
      background: #fff;
      width: 392px;
      height: 405px;
      box-shadow: 0px 2px 15px rgba(0, 77, 140, 0.15);
      opacity: 1;
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      box-sizing: border-box;
      padding-bottom: 26px;
      .title {
        line-height: 77px;
        text-align: center;
        border-bottom: 1px solid #dddddd;
        font-weight: bold;
        color: #333;
        font-size: 24px;
      }

      .code {
        padding: 30px 0;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        .code-content {
          width: 55%;
          .qrcode {
            width: 100%;
          }
        }

        .qrcode-success {
          display: flex;
          flex-direction: column;
          align-items: center;

          .login-box_titles {
            margin-bottom: 10px;
          }
        }
        .qrcode-error {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          .login-boxes {
            position: relative;
            width: 150px;
            height: 150px;
            border: 1px solid #cdcdcd;
            padding: 10px;

            .qrcode {
              width: 100%;
              height: 100%;
            }

            .qrcode-center {
              position: absolute;
              top: 43%;
              left: 16%;
            }
          }

          .qrcode-error-footer {
            margin-top: 40px;
          }
        }
        .qrcode-cancel {
          .login-box_titles {
            margin-top: 10px;
            color: #bf443d;
          }
        }
      }

      .desc {
        line-height: 26px;
        font-size: 20px;
        text-align: center;
        color: #bbbbbb;
      }
    }
  }
  .page-footer {
    position: fixed;
    bottom: 5px;
    left: 0;
    width: 100%;
    text-align: center;
    height: 16px;
    color: #000;
    font-size: 11px;
    .beian {
      color: #000;
    }
  }
}
</style>
